import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css';
import { AuthProvider } from "./context/AuthContext";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'; // اضافه کردن این خط

const root = createRoot(document.getElementById('root'));

// ایجاد نمونه کلاینت (یک بار ساخته می‌شود)
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </QueryClientProvider>
);
